__turbopack_context__.v({
  "arrow": "TurnrDropdownSelect-module-scss-module__HNBEzW__arrow",
  "arrow-icon": "TurnrDropdownSelect-module-scss-module__HNBEzW__arrow-icon",
  "arrow-with-tooltip": "TurnrDropdownSelect-module-scss-module__HNBEzW__arrow-with-tooltip",
  "backdrop": "TurnrDropdownSelect-module-scss-module__HNBEzW__backdrop",
  "close-btn": "TurnrDropdownSelect-module-scss-module__HNBEzW__close-btn",
  "custom-select": "TurnrDropdownSelect-module-scss-module__HNBEzW__custom-select",
  "disabled": "TurnrDropdownSelect-module-scss-module__HNBEzW__disabled",
  "error": "TurnrDropdownSelect-module-scss-module__HNBEzW__error",
  "fieldset": "TurnrDropdownSelect-module-scss-module__HNBEzW__fieldset",
  "floating-label": "TurnrDropdownSelect-module-scss-module__HNBEzW__floating-label",
  "hide-arrow": "TurnrDropdownSelect-module-scss-module__HNBEzW__hide-arrow",
  "key-navigated-option": "TurnrDropdownSelect-module-scss-module__HNBEzW__key-navigated-option",
  "label-locked": "TurnrDropdownSelect-module-scss-module__HNBEzW__label-locked",
  "legend": "TurnrDropdownSelect-module-scss-module__HNBEzW__legend",
  "no-title": "TurnrDropdownSelect-module-scss-module__HNBEzW__no-title",
  "open": "TurnrDropdownSelect-module-scss-module__HNBEzW__open",
  "option": "TurnrDropdownSelect-module-scss-module__HNBEzW__option",
  "option-disabled": "TurnrDropdownSelect-module-scss-module__HNBEzW__option-disabled",
  "options": "TurnrDropdownSelect-module-scss-module__HNBEzW__options",
  "placeholder": "TurnrDropdownSelect-module-scss-module__HNBEzW__placeholder",
  "select": "TurnrDropdownSelect-module-scss-module__HNBEzW__select",
  "select-arrow-active": "TurnrDropdownSelect-module-scss-module__HNBEzW__select-arrow-active",
  "select-hide": "TurnrDropdownSelect-module-scss-module__HNBEzW__select-hide",
  "select-selected": "TurnrDropdownSelect-module-scss-module__HNBEzW__select-selected",
  "selected-option": "TurnrDropdownSelect-module-scss-module__HNBEzW__selected-option",
  "size-small": "TurnrDropdownSelect-module-scss-module__HNBEzW__size-small",
  "tooltip-wrapper": "TurnrDropdownSelect-module-scss-module__HNBEzW__tooltip-wrapper",
  "value-changed": "TurnrDropdownSelect-module-scss-module__HNBEzW__value-changed",
  "value-changed-box": "TurnrDropdownSelect-module-scss-module__HNBEzW__value-changed-box",
});
